import { useRef, useState, useTransition } from 'react';

import { cn } from 'src/lib/utils';
import { type IOwnershipFilter } from 'src/containers/Home/model';
import { OwnershipFilterSelect } from 'src/containers/Home/ui';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

import ApplicationsList from './ApplicationsList';

type Props = {
  className?: string;
};

const ProtectionByApplicationCard = ({ className }: Props) => {
  const [ownershipFilter, setOwnershipFilter] = useState<IOwnershipFilter>('all');
  const scrollAreaRef = useRef<HTMLDivElement>(null);
  const [isFilterPending, startFilterTransition] = useTransition();

  const handleOwnershipFilterChange = (value: IOwnershipFilter) => {
    startFilterTransition(() => setOwnershipFilter(value));
    if (scrollAreaRef.current) scrollAreaRef.current.scrollTop = 0;
  };

  return (
    <Card className={cn('flex h-160 flex-col lg:h-auto lg:min-h-160', className)}>
      <CardHeader className="gap-1.5 space-y-0 p-6 pb-3">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          <CardTitle>Protection by application</CardTitle>
          <OwnershipFilterSelect
            value={ownershipFilter}
            onValueChange={handleOwnershipFilterChange}
            aria-label="Filter applications"
          />
        </div>
        <CardDescription>How much protection each application has in place.</CardDescription>
      </CardHeader>
      <div
        ref={scrollAreaRef}
        data-testid="applications-scroll-area"
        aria-busy={isFilterPending}
        className={cn('min-h-0 grow basis-0 overflow-y-auto pb-6 transition-opacity', isFilterPending && 'opacity-60')}
      >
        <ApplicationsList ownershipFilter={ownershipFilter} scrollAreaRef={scrollAreaRef} />
      </div>
    </Card>
  );
};

export default ProtectionByApplicationCard;
